const { InspectorControls, MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { PanelBody, Button, Flex, FlexItem, FlexBlock } = wp.components;

import CarSpeed from './speed';
import CarLoop from './loop';
import CarPager from './pager';
import CarControls from './controls';

const Inspector = (props) => {
	
	const { attributes, setAttributes } = props;
	
	const onSelectMedia = (media) => {
		let imageIDs = []
		
		media.map((image, index) => (
				imageIDs.push(image.id)
			)
		)
		
		setAttributes({
			clientId	: props.clientId,
			mediaId		: imageIDs
		})
	}
		
	const removeMedia = () => {
		
		props.media = undefined
		
		setAttributes({
			clientId	: '',
			mediaId		: []
		})
	}

	return (
		<InspectorControls>
			<PanelBody
				title={'Carousel Settings'}
				initialOpen={ true }
			>
				<div className={"inspector_carousel_images"}>
					<MediaUploadCheck>
					    <MediaUpload
					        allowedTypes={ ['image'] }
					        gallery={true}
					        multiple={true}
					        onSelect={onSelectMedia}
							value={attributes.mediaId}
					        render={({open}) => (
						        <p>
						            <Button 
						            	className={props.media == undefined ? 'editor-post-featured-image__toggle' : 'editor-post-featured-image__preview'}
						            	onClick={open}
						            >
						            	{props.media == undefined && 'Choose images'}
						            	
						            	{props.media != undefined && 
											<Flex>
												<FlexBlock>
													{props.media.map(image => (
														<FlexItem>
												            <img 	src={image.source_url}
																	height={image.media_details.sizes.medium.height}
																	width={image.media_details.sizes.medium.width}
															/>
														</FlexItem>
													))}
												</FlexBlock>
											</Flex>
										}
						            </Button>
					            </p>
					        )}
					    />
					</MediaUploadCheck>
					
					{props.media != undefined &&
						<MediaUploadCheck>
							<MediaUpload
								allowedTypes={ ['image'] }
						        gallery={true}
						        multiple={true}
						        onSelect={onSelectMedia}
								value={attributes.mediaId}
								render={({open}) => (
									<p>
										<Button onClick={open} isDefault isLarge>{'Edit/Replace'}</Button>
									</p>
								)}
							/>
						</MediaUploadCheck>
					}
		
					{attributes.mediaId.length != 0 && 
						<MediaUploadCheck>
							<p>
								<Button onClick={removeMedia} isLink isDestructive>{'Remove'}</Button>
							</p>
						</MediaUploadCheck>
					}
				</div>
				
					<CarSpeed {...props} />
					
					<CarLoop {...props} />
					
					<CarPager {...props} />
					
					<CarControls {...props} />
					
			</PanelBody>
		</InspectorControls>
	)
}

export default Inspector;